<template>
  <div class="my_enroll_detail">
    <div class="tit">
      <span>
        <router-link to="/personal_center/park_user/my_enroll/my_enroll_record" class="back">
          <i class="el-icon-arrow-left"></i>
        </router-link>我的报名详情
      </span>
    </div>
    <div class="body_content">
      <el-row v-if="enroll_list">
        <el-col :span="24">
          <div class="detail_l">活动信息：</div>
          <div class="detail_r" v-if="enroll_list.active_name">
            <router-link class="table_btn" :to="`/garden_activity_details?id=${enroll_list.active_id}`">{{enroll_list.active_name}}</router-link>
          </div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">活动类型：</div>
          <div
              class="detail_r"
              v-if="enroll_list.active_type_name"
          >{{ enroll_list.active_type_name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">活动地点：</div>
          <div
              class="detail_r"
              v-if="enroll_list.active_province_name"
          >
            {{ enroll_list.active_province_name }}{{ enroll_list.active_city_name }}{{ enroll_list.active_county_name }}{{enroll_list.active_address}}</div>
          <div v-else>暂无</div>
        </el-col>
         <el-col :span="24">
          <div class="detail_l">活动时间：</div>
           <div class="detail_r" v-if="enroll_list.active_start_date">{{ enroll_list.active_start_date }}—{{enroll_list.active_end_date}}</div>
           <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">姓名：</div>
          <div class="detail_r">{{ enroll_list.name }}&nbsp;</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">手机：</div>
          <div class="detail_r">{{ enroll_list.mobile }}&nbsp;</div>
        </el-col>
        <el-col :span="24" v-if="enroll_list.company">
          <div class="detail_l">单位：</div>
          <div class="detail_r">{{ enroll_list.company }}&nbsp;</div>
        </el-col>
        <el-col :span="24" v-if="enroll_list.position">
          <div class="detail_l">职位：</div>
          <div class="detail_r">{{ enroll_list.position }}&nbsp;</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">报名时间：</div>
          <div class="detail_r" v-if="enroll_list.create_date">{{ enroll_list.create_date }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">个人图片：</div>
          <div class="cover" v-if="enroll_list.imagePath">
            <el-image
                :src="enroll_list.imagePath"
                :preview-src-list="[enroll_list.imagePath]">
            </el-image>
          </div>
        </el-col>
        <el-col :span="24" v-for="item in enroll_list.signForms">
          <div class="detail_l">{{item.name}}：</div>
          <div class="detail_r">{{ item.value }}</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">审核状态：</div>
          <div class="detail_r" v-if="enroll_list.status_name">{{ enroll_list.status_name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">审核说明：</div>
          <div class="detail_r">{{ enroll_list.remark }}&nbsp;</div>
        </el-col>
        <!-- <el-col :span="5" v-if="enroll_list.right_code">
          <div class="detail_l">确认码：</div>
        </el-col>
        <el-col :span="19" v-if="enroll_list.right_code">
          <div class="detail_r">{{ enroll_list.right_code }}&nbsp;</div>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      enroll_list: {} //详情
    };
  },
  created() {
    this.getActiveSigns();
  },
  methods: {
    // 返回
    goBack() {
      this.$router.push({
        path: "/personal_center/park_user/my_enroll/my_enroll_record"
      });
    },
    // 获取详情
    getActiveSigns() {
      this.api
        .getActiveSigns({
          id: this.$route.query.id
        })
        .then(res => {
          if (res.error.err_code != 0) return;
          this.enroll_list = res.obj.list[0];
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.my_enroll_detail {
  line-height: 41px;
  .tit {
    .back {
      display: inline-block;
      width: 38px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-right: 14px;
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .el-col{
    display: flex;
    font-size: 14px;
  }
  .detail_l {
    color: #999;
  }
  .detail_r {
  }
  .table_btn{
    color: #117eff;
  }
  .cover{
    display: flex;
    .el-image{
      width: 80px;
      height: 80px;
      margin-right: 20px;
      border-radius: 6px;
      background-color: #f0f0f0;
      /*img{*/
      /*    width: 100%;*/
      /*}*/
    }
  }
}
</style>
